// extracted by mini-css-extract-plugin
export default {"link":"AddToReport_link__Hil5P"};